import React from "react";

import { connect } from "react-redux";
import { string } from "prop-types";

import OnboardImage from "../OnboardImage";
import * as style from "./style.module.scss";

const Done = ({ firstName }) => {
  const desktopText = (
    <p>
      Continue to your profile to complete more questions - the more <br />
      details you add, the better your chances at getting hired soon!
    </p>
  );
  const mobileText =
    "Continue to your profile to complete more questions - the more details you add, the better your chances at getting hired soon!";

  return (
    <div
      className={`${style.wellDone__container} d-flex flex-column justify-content-between`}
    >
      <OnboardImage
        title={`Well done, ${firstName}!`}
        subtitle=""
        mobileDescription={mobileText}
        desktopDescription={desktopText}
        imagePath="/images/well_done.svg"
        imageClassName={`d-block ${style.wellDone__image}`}
        className={`col-lg-12 px-0 ${style.wellDone_imageBackground}`}
        buttonUnderText={true}
      />
    </div>
  );
};

const mapStateToProps = ({
  core: {
    app: { firstName },
  },
}) => ({ firstName });
const mapDispatchToProps = {};
const withRedux = connect(mapStateToProps, mapDispatchToProps);

Done.propTypes = {
  firstName: string,
};

export default withRedux(Done);
